import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const base =
  "group inline-flex items-center justify-center gap-2 px-6 py-3.5 text-sm font-medium tracking-wide transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-kv-electric focus-visible:ring-offset-2 focus-visible:ring-offset-kv-bg select-none";

const styles = {
  primary:
    "bg-kv-off text-kv-bg border border-kv-off hover:bg-kv-navy hover:shadow-[0_0_24px_rgba(0,0,0,0.12)]",
  secondary:
    "bg-transparent text-kv-off border border-kv-steel/60 hover:border-kv-off hover:bg-kv-bg2",
  ghost:
    "bg-transparent text-kv-grey hover:text-kv-off border border-transparent",
};

export default function Cta({
  to,
  href,
  children,
  variant = "primary",
  arrow = false,
  className = "",
  testId,
  ...rest
}) {
  const cls = `${base} ${styles[variant]} ${className}`;
  const inner = (
    <>
      {children}
      {arrow && (
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      )}
    </>
  );
  if (to) {
    return (
      <Link to={to} className={cls} data-testid={testId} {...rest}>
        {inner}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} data-testid={testId} {...rest}>
        {inner}
      </a>
    );
  }
  return (
    <button className={cls} data-testid={testId} {...rest}>
      {inner}
    </button>
  );
}
